import type { Component } from "vue";

export const routes = [
  {
    path: "/product/manage",
    name: "product-manager",
    component: (): Promise<Component> => import("./views/ProductManager.vue"),
    meta: { requiresAuth: true, requiredRoles: [], requiredGroups: [] },
  },
  {
    path: "/product/import",
    name: "product-import",
    component: (): Promise<Component> => import("./views/ProductImport.vue"),
    meta: { requiresAuth: true, requiredRoles: [], requiredGroups: [] },
  },
  {
    path: "/product/brand-families",
    name: "product-brand-families",
    component: (): Promise<Component> => import("./views/ProductBrandFamilies.vue"),
    meta: { requiresAuth: true, requiredRoles: [], requiredGroups: [] },
  },
];
